<template>
  <svg
    width="194"
    height="160"
    viewBox="0 0 194 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_56_2700)">
      <path
        d="M66.336 31.936C65.728 31.936 65.248 31.968 65.056 31.968C52.128 32.928 41.248 42.304 38.528 55.136C35.008 55.264 32.224 58.144 32.224 61.664V71.904C32.224 75.2 34.624 77.92 37.792 78.368V120.32C34.624 120.8 32.224 123.488 32.224 126.784V137.024C32.224 140.32 34.624 143.04 37.792 143.488V150.464C37.792 152.416 39.36 153.984 41.312 153.984H118.688C120.64 153.984 122.208 152.416 122.208 150.464V143.488C125.376 143.008 127.776 140.32 127.776 137.024V126.784C127.776 123.488 125.376 120.768 122.208 120.32V78.432C125.376 77.952 127.776 75.264 127.776 71.968V61.728C127.776 58.208 125.024 55.36 121.568 55.2C118.848 42.304 107.872 32.896 94.848 32C94.624 32 93.856 31.968 92.928 31.968C90.528 31.936 88.576 29.984 88.576 27.584V12.416H80H70.688V27.552C70.688 29.952 68.736 31.904 66.336 31.936Z"
        fill="#9AE0FA"
      />
      <path opacity="0.22" d="M70.688 12.416V24.704H88.544V12.416H80H70.688Z" fill="#1491DA" />
      <path
        d="M55.456 80.16H104.512C107.392 80.16 109.728 82.496 109.728 85.376V111.104C109.728 113.984 107.392 116.32 104.512 116.32H55.456C52.576 116.32 50.24 113.984 50.24 111.104V85.376C50.24 82.496 52.576 80.16 55.456 80.16Z"
        fill="#1491DA"
      />
      <path
        opacity="0.36"
        d="M72.864 12.416V27.552C72.864 29.952 71.424 31.904 69.632 31.936C69.184 31.936 68.832 31.968 68.672 31.968C59.04 32.928 50.944 42.304 48.928 55.136C46.304 55.264 44.256 58.144 44.256 61.664V71.904C44.256 75.2 46.048 77.92 48.416 78.368V120.32C46.048 120.8 44.256 123.488 44.256 126.784V137.024C44.256 140.32 46.048 143.04 48.416 143.488V150.464C48.416 152.416 49.6 153.984 51.04 153.984H58.88C57.824 153.984 56.992 152.416 56.992 150.464V143.488C55.296 143.008 53.984 140.32 53.984 137.024V126.784C53.984 123.488 55.296 120.768 56.992 120.32V78.432C55.296 77.952 53.984 75.264 53.984 71.968V61.728C53.984 58.176 55.488 55.328 57.376 55.2C58.848 42.368 64.736 32.96 71.744 32.032C71.84 32.032 72.096 32 72.448 32C73.76 31.968 74.816 30.016 74.816 27.616V12.416H72.864Z"
        fill="white"
      />
      <path
        opacity="0.22"
        d="M32.256 137.408C32.416 140.352 34.528 142.752 37.344 143.392H122.656C125.472 142.752 127.552 140.352 127.744 137.408H32.256Z"
        fill="#1491DA"
      />
      <path
        opacity="0.22"
        d="M32.256 72.352C32.416 75.296 34.528 77.696 37.344 78.336H122.656C125.472 77.696 127.552 75.296 127.744 72.352H32.256Z"
        fill="#1491DA"
      />
      <path
        opacity="0.36"
        d="M32.224 126.4C32.384 123.456 34.496 121.056 37.312 120.416H122.624C125.44 121.056 127.52 123.456 127.712 126.4H32.224Z"
        fill="white"
      />
      <path
        opacity="0.36"
        d="M32.256 61.28C32.416 58.336 34.528 55.936 37.344 55.296H122.656C125.472 55.936 127.552 58.336 127.744 61.28H32.256Z"
        fill="white"
      />
      <path
        opacity="0.22"
        d="M86.208 12.416V27.552C86.208 29.952 87.616 31.904 89.376 31.936C90.048 31.936 90.624 31.968 90.784 31.968C100.256 32.832 108.224 42.24 110.208 55.168C112.736 55.328 114.72 58.176 114.72 61.696V71.936C114.72 75.232 112.96 77.952 110.656 78.4V120.32C112.96 120.8 114.72 123.488 114.72 126.784V137.024C114.72 140.32 112.96 143.04 110.656 143.488V150.464C110.656 152.416 109.504 153.984 108.096 153.984H118.656C120.608 153.984 122.176 152.416 122.176 150.464V143.488C125.344 143.008 127.744 140.32 127.744 137.024V126.784C127.744 123.488 125.344 120.768 122.176 120.32V78.432C125.344 77.952 127.744 75.264 127.744 71.968V61.728C127.744 58.208 124.992 55.36 121.536 55.2C118.816 42.304 107.84 32.896 94.816 32C94.592 32 93.824 31.968 92.896 31.968C90.496 31.936 88.544 29.984 88.544 27.584V12.416H86.208Z"
        fill="#1491DA"
      />
      <path
        d="M71.776 6.01599C70.592 6.01599 69.664 6.97599 69.664 8.12799V18.944C69.664 20.128 70.624 21.056 71.776 21.056H79.136V22.4C79.136 23.264 79.808 23.936 80.672 23.936C81.536 23.936 82.208 23.264 82.208 22.4V21.056H87.104C88.288 21.056 89.216 20.096 89.216 18.944V8.15999C89.216 6.97599 88.288 6.04799 87.104 6.04799H71.776V6.01599Z"
        fill="#1491DA"
      />
      <path
        d="M74.848 6.01599C73.664 6.01599 72.736 6.97599 72.736 8.12799V18.944V21.056H75.488V18.944V8.15999C75.488 6.97599 76.416 6.04799 77.6 6.04799H74.848V6.01599Z"
        fill="#67BEF1"
      />
      <path
        d="M80.576 6.01599C81.76 6.01599 82.688 6.97599 82.688 8.12799V18.944V21.056H87.104C88.288 21.056 89.216 20.096 89.216 18.944V8.15999C89.216 6.97599 88.288 6.04799 87.104 6.04799H80.576V6.01599Z"
        fill="#147BBC"
      />
      <path
        d="M125.165 59.7796C125.165 59.7796 125.424 63.5084 124.103 65.9864C122.758 68.488 116.669 76.6772 115.654 84.3708C114.616 92.0644 119.336 102.732 118.486 108.301C117.636 113.871 115.324 125.057 113.766 136.574C112.208 148.091 118.297 157.106 118.297 157.106H133H147.703C147.703 157.106 153.792 148.091 152.234 136.574C150.676 125.057 148.364 113.871 147.514 108.301C146.664 102.732 151.384 92.0644 150.346 84.3708C149.308 76.6772 143.219 68.488 141.897 65.9864C140.552 63.4848 140.835 59.7796 140.835 59.7796H133H125.165Z"
        fill="#9AE0FA"
      />
      <path
        d="M119.312 74.0812C117.66 77.22 116.126 80.8544 115.654 84.3708C114.97 89.5392 116.858 96.0764 117.92 101.481H148.08C149.142 96.0764 151.054 89.5628 150.346 84.3708C149.874 80.8308 148.34 77.22 146.688 74.0812H119.312Z"
        fill="#118CD4"
      />
      <path
        opacity="0.15"
        d="M138.664 59.7796C138.664 59.7796 138.475 63.5084 139.443 65.9864C140.41 68.488 144.824 76.6772 145.579 84.3708C146.334 92.0644 142.912 102.732 143.526 108.301C144.139 113.871 145.815 125.057 146.948 136.574C148.057 148.091 143.667 157.106 143.667 157.106H147.726C147.726 157.106 153.815 148.091 152.258 136.574C150.7 125.057 148.387 113.871 147.538 108.301C146.688 102.732 151.408 92.0644 150.37 84.3708C149.331 76.6772 143.242 68.488 141.921 65.9864C140.576 63.4848 140.859 59.7796 140.859 59.7796H138.664Z"
        fill="#118CD4"
      />
      <path
        opacity="0.36"
        d="M127.383 59.7796C127.383 59.7796 127.572 63.5084 126.628 65.9864C125.684 68.488 119.878 76.6772 119.17 84.3708C118.462 92.0644 121.743 102.732 121.153 108.301C120.563 113.871 118.934 125.057 117.849 136.574C116.763 148.091 121.011 157.106 121.011 157.106H126.274C126.274 157.106 123.206 148.091 123.985 136.574C124.764 125.057 125.944 113.871 126.368 108.301C126.793 102.732 124.41 92.0644 124.929 84.3708C125.448 76.6772 128.54 68.488 129.2 65.9864C129.885 63.4848 129.743 59.7796 129.743 59.7796H127.383Z"
        fill="white"
      />
      <path
        d="M127.902 46.894C126.109 46.894 124.646 48.3572 124.646 50.1508V56.7116H124.126C123.489 56.7116 122.97 57.2308 122.97 57.868V60.228H143.03V57.868C143.03 57.2308 142.511 56.7116 141.874 56.7116H141.354V50.1744C141.354 48.3808 139.891 46.9176 138.098 46.9176H127.902V46.894Z"
        fill="#118CD4"
      />
      <path
        d="M133.307 46.894C135.1 46.894 136.564 48.3572 136.564 50.1508V56.7116H137.083C137.72 56.7116 138.239 57.2308 138.239 57.868V60.228H143.03V57.868C143.03 57.2308 142.511 56.7116 141.874 56.7116H141.354V50.1744C141.354 48.3808 139.891 46.9176 138.098 46.9176H133.307V46.894Z"
        fill="#147BBC"
      />
      <path
        opacity="0.36"
        d="M130.64 46.894C129.602 46.894 128.776 48.3572 128.776 50.1508V56.7116H128.492C128.115 56.7116 127.832 57.2308 127.832 57.868V60.228H125.094V57.868C125.094 57.2308 125.401 56.7116 125.755 56.7116H126.038V50.1744C126.038 48.3808 126.864 46.9176 127.902 46.9176H130.64V46.894Z"
        fill="white"
      />
      <path
        opacity="0.36"
        d="M124.646 56.688V56.7352H124.126C123.536 56.7352 123.041 57.2072 122.97 57.7972H143.006C142.959 57.2072 142.464 56.7352 141.85 56.7352H141.331V56.688H124.646Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_56_2700">
        <rect width="194" height="160" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
